import { locale } from 'svelte-i18n';
import { derived } from 'svelte/store';
const arRegex = /^ar-?/i;
export default derived(locale, $locale => {
    return arRegex.test($locale) ? 'rtl' : 'ltr';
});
